import React from 'react';
import { CheckIcon } from 'lucide-react';
import { services } from '../data/services';
import { WhatsAppButton } from './WhatsAppButton';
export function Services() {
  return <section id="servicios" className="bg-ivory-50" data-id="element-66" data-mp="1du0ww9sazw7t">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:px-8 lg:py-28" data-id="element-67" data-mp="1dshg8i2qjj5i">
        <div className="max-w-3xl" data-id="element-68" data-mp="18vr240ahqxmq">
          <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-gold-600" data-id="element-69" data-mp="18uoblth2yx7c">
            Consultas y prácticas
          </p>
          <h2 className="mt-5 font-display text-2xl font-semibold leading-snug text-emerald-900 sm:text-4xl" data-id="element-70" data-mp="z5eicaai38hn">
            Nuestros servicios
          </h2>
          <p className="mt-6 text-base leading-relaxed text-graphite-700" data-id="element-71" data-mp="u6bdoqyfn4a7">
            Amarres, pactos, rituales y trabajos de protección dentro de la
            brujería y la hechicería tradicional. Cada servicio se atiende de
            forma personalizada y con total reserva.
          </p>
        </div>

        <div className="mt-14 grid gap-8 md:grid-cols-2 lg:grid-cols-3" data-id="element-72" data-mp="g8dc6m57n2c4">
          {services.map(service => <article key={service.id} className="flex flex-col overflow-hidden rounded-sm border border-sage-200 bg-white shadow-[0_2px_10px_rgba(28,32,27,0.05)]" data-id="element-73" data-mp="36an02wgydvwn">
              <img src={service.image} alt={service.imageAlt} className="h-52 w-full object-cover" loading="lazy" decoding="async" data-id="element-74" data-mp="32avzy25je3fg" />
              <div className="flex flex-1 flex-col border-t-2 border-gold-400 p-7" data-id="element-75" data-mp="3u2buqjh8ywgr">
                <h3 className="font-display text-xl font-semibold uppercase tracking-wide text-emerald-800" data-id="element-76" data-mp="3g2j4sqdjok9u">
                  {service.title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-graphite-700" data-id="element-77" data-mp="3l3gnd42gvgbv">
                  {service.description}
                </p>
                <ul className="mt-6 space-y-3" data-id="element-78" data-mp="29mqeteakmcf3">
                  {service.points.map(point => <li key={point} className="flex gap-3 text-sm leading-relaxed text-graphite-700" data-id="element-79" data-mp="1pkm1voc0jbpy">
                      <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-gold-600" aria-hidden="true" data-id="element-80" data-mp="1lkv779jd8bg5" />
                      <span data-id="element-81" data-mp="1bsfno7sf7et5">{point}</span>
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>
      </div>

      <div className="bg-emerald-800" data-id="element-82" data-mp="11tqhvddstkt9">
        <div className="mx-auto flex max-w-6xl flex-col items-start gap-6 px-5 py-14 lg:flex-row lg:items-center lg:justify-between lg:px-8" data-id="element-83" data-mp="11wuqcmyar2pq">
          <div className="max-w-2xl" data-id="element-84" data-mp="suv9pvr720nb">
            <div className="hairline h-px w-24" aria-hidden="true" data-id="element-85" data-mp="svwlk2g1ar63" />
            <p className="mt-5 font-display text-2xl leading-snug text-ivory-50 sm:text-3xl" data-id="element-86" data-mp="2s5mmaxb2t75n">
              ¿No sabes qué trabajo corresponde a tu caso?
            </p>
            <p className="mt-3 text-sm leading-relaxed text-sage-100" data-id="element-87" data-mp="2urvpmfmqg33l">
              Escríbenos y lo revisamos de forma privada y sin compromiso.
            </p>
          </div>
          <WhatsAppButton variant="onEmerald" className="w-full lg:w-auto" data-id="element-88" data-mp="2zo42fmdgjk7l" />
        </div>
      </div>
    </section>;
}